
/* styles */
require("!!../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader!../../../vue-loader/lib/style-compiler/index?{\"id\":\"data-v-80ef5bee\",\"scoped\":false,\"hasInlineConfig\":false}!less-loader!../../../vue-loader/lib/selector?type=styles&index=0!./circularProgress.vue")

var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./circularProgress.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-80ef5bee\"}!../../../vue-loader/lib/selector?type=template&index=0!./circularProgress.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/muse-ui/src/circularProgress/circularProgress.vue
// module id = 346
// module chunks = 1